export default [

    {
        path: '',
        name: 'boas-praticas',
        redirect: { name: 'boas-praticas-timeline' },
    },

    {
        path: 'timeline',
        name: 'boas-praticas-timeline',
        component: () => import('@/aplicacao/modulos/boas-praticas/Timeline'),
        meta: { autenticacao: true, permissao: 'ROLE_BOAS_PRATICAS' },
    },

    {
        path: 'meus-posts',
        name: 'boas-praticas-meus-posts',
        component: () => import('@/aplicacao/modulos/boas-praticas/MeusPosts'),
        meta: { autenticacao: true, permissao: 'ROLE_BOAS_PRATICAS_POSTAR' },
    },

    {
        path: 'posts/:id',
        name: 'boas-praticas-post-visualizar',
        component: () => import('@/aplicacao/modulos/boas-praticas/PostVisualizacao'),
        meta: { autenticacao: true, permissao: 'ROLE_BOAS_PRATICAS_POSTAR' },
    },

    {
        path: 'posts/editar/:id',
        name: 'boas-praticas-post-editar',
        component: () => import('@/aplicacao/modulos/boas-praticas/PostEditavel'),
        meta: { autenticacao: true, permissao: 'ROLE_BOAS_PRATICAS_POSTAR' },
    },

    {
        path: 'aprovacao',
        name: 'boas-praticas-aprovacao-listagem',
        component: () => import('@/aplicacao/modulos/boas-praticas/AprovacaoListagem'),
        meta: { autenticacao: true, permissao: 'ROLE_BOAS_PRATICAS_APROVAR' },
    },

    {
        path: 'aprovacao/:id',
        name: 'boas-praticas-aprovacao-interna',
        component: () => import('@/aplicacao/modulos/boas-praticas/AprovacaoInterna'),
        meta: { autenticacao: true, permissao: 'ROLE_BOAS_PRATICAS_APROVAR' },
    },

]
